import React from 'react';
import PropTypes from 'prop-types';
import { Message } from 'semantic-ui-react';

function getSuccessMessage(success) {
  // eslint-disable-next-line no-console
  console.error('Displaying Success', success);
  if (success instanceof Object) {
    return success.message;
  }
  return success;
}

function SuccessMessage({ success }) {
  return (
    <Message positive>
      <Message.Header>{getSuccessMessage(success)}</Message.Header>
    </Message>
  );
}

SuccessMessage.propTypes = {
  success: PropTypes.object,
};

export default SuccessMessage;
